import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BillState, FlowInvoiceInsight } from 'src/app/_types/billing.types';
import { BillStatusBadgeComponent } from 'src/app/Dashboard/billing/bill-status-badge/bill-status-badge.component';

@Component({
  selector: 'app-flow-invoice-status-renderer',
  standalone: true,
  imports: [BillStatusBadgeComponent],
  template: `<app-bill-status-badge [status]="status" />`,
})
export class FlowInvoiceStatusRendererComponent
  implements ICellRendererAngularComp
{
  status: BillState = 'TO_BE_VALIDATED';

  agInit(params: ICellRendererParams<FlowInvoiceInsight>): void {
    if (params.data) this.status = params.data.status;
  }

  refresh(): boolean {
    return false;
  }
}
